import PropTypes from "prop-types";
import React from "react";

import MoveDestinationForm from "v2/components/responsive/MoveDestinationForm";

const MoveDestinationPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <MoveDestinationForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

MoveDestinationPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default MoveDestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/MoveDestinationPage.js
 **/